import { createSlice } from "@reduxjs/toolkit";

//STATE
const state = {
  rows: [],
  showDialog: false,
  isLoading: false,
};

//STORE SLICE
export const itemStatusAddSlice = createSlice({
  name: "itemStatusAddSlice",
  initialState: state,
  //REDUCER
  reducers: {
    showAddItemStatusDialog(state) {
      return {
        ...state,
        showDialog: true,
      };
    },
    closeAddItemStatusDialog(state) {
      return {
        ...state,
        showDialog: false,
      };
    },
    showLoading(state) {
      return {
        ...state,
        isLoading: true,
      };
    },
    hideLoading(state) {
      return {
        ...state,
        isLoading: false,
      };
    },    
  },
});

//ACTIONS
export const {
  showAddItemStatusDialog,
  closeAddItemStatusDialog,
  showLoading,
  hideLoading
} = itemStatusAddSlice.actions;

export default itemStatusAddSlice.reducer;
